// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_jo-0";
export var optionCard = "_jo-1";